import { notificationsOutline, warningOutline } from 'ionicons/icons';

import { Color } from '@ionic/core';
import { t } from './i18n';
import { toastController } from '@ionic/vue';

export const showSuccessToast = async (
  message: string,
  icon?: string,
  position: 'top' | 'middle' | 'bottom' = 'top',
  duration = 3000,
) => {
  showToast(message, 'success', position, duration, icon);
};

export const showWarnToast = async (
  message: string,
  icon = warningOutline,
  position: 'top' | 'middle' | 'bottom' = 'top',
  duration = 3000,
) => {
  showToast(message, 'warning', position, duration, icon);
};

export const showErrorToast = async (
  message = t('base.errorOccured'),
  icon = warningOutline,
  position: 'top' | 'middle' | 'bottom' = 'top',
  duration = 3000,
) => {
  showToast(message, 'danger', position, duration, icon);
};

export const showNotificationToast = async (
  title = t('toast.newNotification'),
  message?: string,
  onTap?: () => void,
  icon = notificationsOutline,
  position: 'top' | 'middle' | 'bottom' = 'top',
  duration = 5000,
) => {
  const toast = await toastController.create({
    header: title,
    message,
    position,
    icon,
    duration,
    color: 'primary',
    swipeGesture: 'vertical',
    cssClass: onTap ? 'clickable' : undefined,
  });

  if (onTap) {
    toast.addEventListener('click', () => {
      onTap();
      toast.dismiss();
    });
  }

  await toast.present();
};

const showToast = async (
  message: string,
  color: Color,
  position: 'top' | 'middle' | 'bottom',
  duration: number,
  icon?: string,
) => {
  const toast = await toastController.create({
    message,
    position,
    icon,
    duration,
    color,
    buttons: [
      {
        text: t('base.dismiss'),
        role: 'cancel',
      },
    ],
  });

  await toast.present();
};
